import { User } from '../ifmsTypes';

import { now, isIsoBefore } from '../dateUtils';

const UserStorageKey = 'ifms.user';
//const UserLicProdStorageKey = 'ifms.user.licproduct';
const LastEmailStorageKey = 'ifms.lastemail';

class AuthService {
  // constructor() {
  //   this.getUser = this.getUser.bind(this);
  //   this.setUser = this.setUser.bind(this);
  //   this.rememberLastLoginEmail = this.rememberLastLoginEmail.bind(this);
  //   this.isAuthenticated = this.isAuthenticated.bind(this);
  // }
  getUser = () => {
    const userFromStorage = localStorage.getItem(UserStorageKey);
    if (!userFromStorage) {
      return null;
    }

    try {
      return JSON.parse(userFromStorage);
    } catch (err) {
      window.console.error(err);
    }

    return null;
  }
  rememberLastLoginEmail = (email:string) => {
    localStorage.setItem(LastEmailStorageKey, email);
  }
  isDifferentUserLogin = (loginEmail:string) => {
    return localStorage.getItem(LastEmailStorageKey) !== loginEmail;
  }
  setUser = (user:User) => {
    // 260821 hykim: 보안 - remember-me 세션 복원에 필요 없는 민감 필드(비밀번호/2FA 키)는 localStorage에 남기지 않는다
    const { password, isfUserPW, sharedKey, authenticatorUri, ...safeUser } = user as any;
    localStorage.setItem(UserStorageKey, JSON.stringify(safeUser));
  }
  removeUser = () => {
    localStorage.removeItem(UserStorageKey);
  }
  isAuthenticated = () => {
    const currentUser = this.getUser();

    if (!currentUser) {
      return false;
    }

    return isIsoBefore(now(), currentUser.expiresAt);
  }
  // 260821 hykim: 미사용 getUserLoggedAtTimestamp(parseJwt 사용) 제거
  // setUserLicProduct = (licProduct:LicProduct) => {
  //   localStorage.setItem(UserLicProdStorageKey, JSON.stringify(licProduct));
  // }
  // getUserLicProduct = () => {
  //   const userLicFromStorage = localStorage.getItem(UserLicProdStorageKey);
  //   if (!userLicFromStorage) {
  //     return null;
  //   }
  //   try {
  //     return JSON.parse(userLicFromStorage);
  //   } catch (err) {
  //     window.console.error(err);
  //   }
  //   return null;
  // }

  
  
  
}

export default AuthService;
